import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectStore, SessionRepository } from '@frontend-site/shared/core';
import { ProjectLandingPageProvider } from './landing-page.provider';

@Component({ template: '' })
export class ProjectLandingPageComponent implements OnInit {
    constructor(
        private readonly router: Router,
        private readonly store: ProjectStore,
        private readonly session: SessionRepository,
        private readonly projectLandingPageProvider: ProjectLandingPageProvider
    ) {}

    ngOnInit(): void {
        const landingPagePath = this.projectLandingPageProvider.getProjectLandingPath(
            this.store.projectDetails,
            this.session.applicationConfig
        );

        this.router.navigateByUrl(landingPagePath, { replaceUrl: true });
    }
}
